// src/hooks/useRecipe.js
import { useEffect } from 'react'
import { useRecipe as useRecipeContext } from '../contexts/RecipeContext'

/**
 * Fetches your full recipe library once on mount and
 * exposes { recipes, loading }.
 */
export default function useRecipe() {
  const {
    recipes,     // array of { id, title, … }
    loading,     // boolean
    fetchAll,    // function to load them
  } = useRecipeContext()

  useEffect(() => {
    fetchAll()
  }, [fetchAll])

  return { recipes, loading }
}
